import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function AnaStory() {
  return <section id="historia" className="py-24 bg-navy text-cream px-6 relative overflow-hidden" data-id="element-13">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none flex items-center justify-center" data-id="element-14">
        <Quote className="w-96 h-96 text-cream" data-id="element-15" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-17">
          <Quote className="w-12 h-12 text-gold mx-auto mb-8 opacity-80" data-id="element-18" />
          <h2 className="text-3xl md:text-5xl font-serif leading-relaxed mb-10 text-cream" data-id="element-19">
            "En menos de 72 horas, el silencio de hielo se rompió no con un
            grito, sino con una pregunta honesta."
          </h2>

          <div className="w-16 h-px bg-gold mx-auto mb-8" data-id="element-20"></div>

          <p className="text-lg md:text-xl text-cream/80 font-light max-w-2xl mx-auto mb-4" data-id="element-21">
            Thomas, 42 años. Su esposa le había dicho: "Te quiero, pero ya no
            estoy enamorada de ti". Él intentó todo, pero cada acción solo la
            alejaba más.
          </p>
          <p className="text-gold font-medium text-lg" data-id="element-22">
            Hoy, dos años después, son un equipo más fuerte que nunca.
          </p>
        </motion.div>
      </div>
    </section>;
}